import React from 'react';
import { useSettingsRedux } from '../../hooks/useSettingsRedux';
import parentFrameMessaging from '../../services/ParentFrameMessaging';
import './StatusBar.css';

const OfferConfirmedBar = () => {
  const { settings } = useSettingsRedux();

  const handleShoppingCartClick = () => {
    parentFrameMessaging.sendRedirectToCart();
    try {
      const mobileScreenElement = window.parent.document.querySelector('.mobile-screen') as HTMLElement;
      if (mobileScreenElement) {
        mobileScreenElement.style.backgroundImage = "url('img/cart.png')";
      }
    } catch (error) {
      console.error('Error accessing parent document:', error);
    }

    try {
      const appRoot = document.getElementById('root');
      if (appRoot) {
        appRoot.classList.add('fadeout');
      }
    } catch (error) {}
  };

  return (
    <>
      <div className="playmerce-game-statusbar-message">
        {settings?.translations?.bar?.complete ?? 'Your offer is valid for 24 hours.'}
      </div>
      <button className="ok-button" onClick={handleShoppingCartClick}>
        {settings?.translations?.confirm?.acknowledge ?? 'OK'}
      </button>
    </>
  );
};

export default OfferConfirmedBar;
